import { call, put } from 'redux-saga/effects';
import { Messages } from '../../../../codegen/Localize';
import { CreateExtractTasksAction, CreateExtractTasksMode } from '../../../../ts/services/CreateExtractTasksAction';
import { requestFailed } from '../../../actions/RequestFailedAction';
import { CreateRemoteExtractRefreshAction } from '../../../actions/spaces/CreateRemoteExtractRefreshAction';
import { requestSpaceContents } from '../../../actions/spaces/RequestSpaceContentsActions';
import { ServiceLocator } from '../../../ServiceLocator';

export function* handleCreateRemoteExtractRefreshAction(action: CreateRemoteExtractRefreshAction) {
  try {
    // Similar to the logic of openDatasourceRefreshExtractDialog
    // in $\src\vizportalclient\src\app\sagas\spaces\extractTasks\CreateExtractRefreshSaga.ts
    // such that clicking "New Extract Refresh" would open the same tabbed dialog
    const createExtractModule = ServiceLocator.get<CreateExtractTasksAction>('CreateExtractTasksAction');
    const context = ServiceLocator.getAngularActionContext();
    createExtractModule.forDatasource(action.datasource, context, CreateExtractTasksMode.AllowScheduleOnServerAndClient);
    yield put(requestSpaceContents());
  } catch(e) {
    yield put(requestFailed(e, Messages.unexpectedError()));
  }
}